<template>
  <div class="mahatma width">
    <div class="content">
      <p>
        <i class="el-icon-s-home"></i>
        <span @click="$router.replace('/')">网站首页</span> / <span @click="dynamic">维权大圣</span>
      </p>
      <div>
        <pre>
    “<b>维权大圣卡通形象</b>”是广东省版权保护联合会专有的卡通形象，于2004年由广东省版权保护联合会委托艺术设计专家胡杰风创作而成。该形象以孙悟空为原形，金猴站在风火轮上，手中的金箍棒是由《国际版权公约》、《中华人民共和国著作权法》、《中华人民共和国著作权法实施条例》和《计算机软件保护条例》等四部法律、法规名称“铸”成，寓意对侵权盗版行为嫉恶如仇，维权将如唐僧般成功取真经。该形象在充分表达了广东版权保护的理念的同时，使这个惹人喜爱的形象和保护知识产权紧密相连，让维权意识深入人心，视消费者为唐僧，更体现了版权管理部门保护群众利益的决心和信心。
        </pre>
      </div>
    </div>
 
  </div>
</template>

<script>
export default {
  data() {
    return {
   
    };
  },
  mounted() {},
  methods: {
    dynamic() {
      this.$router.replace("/mahatma")
    }
  },
};
</script>
<style scoped>
.mahatma {
  margin: 20px auto;
  display: flex;
}
.content {
  width: 80%;
  margin: 30px auto;
}
.content > p {
  width: 100%;
  border-bottom: 1px solid #ddd;
  padding-bottom: 10px;
  color: gray;
}
.content > p i {
  margin-right: 10px;
}
.content > p span:hover {
  color: #016fb8;
  cursor: pointer;
}
.contact ul {
  margin-top: 10px;
}
.contact ul li {
  font-size: 13px;
  color: gray;
  margin: 10px 0;
}

.content h2 {
  text-align:center;
  margin: 20px 0;
}
.content pre {
	line-height: 40px;
  white-space: pre-wrap;
  word-wrap: break-word;
  color:#26261F;
  font-size: 18px;
}

</style>